module.exports = __webpack_public_path__ + "img/benefit5.a3ee99b8.png";